import { render, staticRenderFns } from "./DataComponentForm.vue?vue&type=template&id=1993b6c2"
import script from "./DataComponentForm.vue?vue&type=script&lang=js"
export * from "./DataComponentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1993b6c2')) {
      api.createRecord('1993b6c2', component.options)
    } else {
      api.reload('1993b6c2', component.options)
    }
    module.hot.accept("./DataComponentForm.vue?vue&type=template&id=1993b6c2", function () {
      api.rerender('1993b6c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/datav/DataComponentForm.vue"
export default component.exports